<pdf-viewer 
  (onError)="error($event)" 
  (after-load-complete)="stopLoader($event)" 
  class="pdf-viewer" 
  [src]="blobUrl"
  [original-size]="false" 
  style="width: 100%; height: 100%"
  *ngIf="blobUrl"
></pdf-viewer>